import ApplicationController from './application_controller';
import { DirectUpload } from '@rails/activestorage';

export default class extends ApplicationController {

  static targets = ['fileInput', 'dropzone', 'previews', 'previewTemplate'];

  initialize() {
    this.preventDefaults = this.preventDefaults.bind(this);
    this.activeUploads = new Set();
  }

  connect() {
    // Prevent default drag behaviours
    ['dragenter', 'dragover', 'dragleave', 'drop'].forEach(eventName => {
      if (this.hasDropzoneTarget) {
        this.dropzoneTarget.addEventListener(eventName, this.preventDefaults, false);
      }
      document.body.addEventListener(eventName, this.preventDefaults, false);
    });
  }

  disconnect() {
    ['dragenter', 'dragover', 'dragleave', 'drop'].forEach(eventName => {
      if (this.hasDropzoneTarget) {
        this.dropzoneTarget.removeEventListener(eventName, this.preventDefaults, false);
      }
      document.body.removeEventListener(eventName, this.preventDefaults, false);
    });
  }

  preventDefaults(event) {
    event.preventDefault();
    event.stopPropagation();
  }

  stopPropagation(event) {
    event.stopPropagation();
  }

  dropHandler(event) {
    event.preventDefault();
    if (event.dataTransfer && event.dataTransfer.files) {
      this.uploadFiles(event.dataTransfer.files);
    }
    if (this.hasDropzoneTarget) {
      this.dropzoneTarget.classList.remove('highlight');
    }
  }

  changeHandler(event) {
    if (event.target && event.target.files) {
      this.uploadFiles(event.target.files);
    }
  }

  dragEnterHandler() {
    console.log("detecting drag enter");
    if (this.hasDropzoneTarget && !this.dropzoneTarget.classList.contains('highlight')) {
      this.dropzoneTarget.classList.add('highlight');
    }
  }

  dragOverHandler() {
    console.log("detecting drag over");
    if (this.hasDropzoneTarget && !this.dropzoneTarget.classList.contains('highlight')) {
      this.dropzoneTarget.classList.add('highlight');
    }
  }

  dragLeaveHandler() {
    console.log("detecting drag leave");
    if (this.hasDropzoneTarget) {
      this.dropzoneTarget.classList.remove('highlight');
    }
  }

  uploadStarted(uploader) {
    this.activeUploads.add(uploader);
  }

  uploadFinished(uploader, success) {
    this.activeUploads.delete(uploader);
    if (this.activeUploads.size === 0) {
      var submit_on_complete = this.fileInputTarget.dataset.submitOnComplete === 'true';
      if (submit_on_complete) {
        var form = this.element.closest('form');
        if (form) {
          this.showOverlay();
          form.submit();
        }
      }
    }
  }


  uploadFiles(files) {
    if (!files) return;
    files = [...files];
    if (files.length === 0) return;

    var url = this.fileInputTarget.dataset.directUploadUrl;
    var accepted_files = this.fileInputTarget.getAttribute('accept')
      .split(',')
      .map(type => type.trim());

    var max_mb = parseFloat(this.fileInputTarget.dataset.maxSizeMb) || 20;
    var max_bytes = max_mb * 1024 * 1024;
    var invalid_size_msg = this.fileInputTarget.dataset.invalidSizeMsg;

    files.forEach(file => {
      // 1. Kontrola velikosti
      if (file.size > max_bytes) {
        var msg = invalid_size_msg.replace('%NAME%', file.name);
        alert(msg);
        return; // Přeskočí tento soubor, ale pokračuje s dalšími
      }

      // 2. Kontrola typu
      if (accepted_files.includes(file.type)) {
        var uploader = new Uploader(file, url, this.previewsTarget, this.previewTemplateTarget, this);
      } else {
        var unknown = this.fileInputTarget.dataset.unknownTypeMsg;
        var msg = this.fileInputTarget.dataset.invalidTypeMsg
          .replace('%NAME%', file.name)
          .replace('%TYPE%', file.type || unknown);
        alert(msg);
      }
    });

    this.fileInputTarget.value = null;
  }

  openFileDialog() {
    this.fileInputTarget.click();
  }

  destroyFile(event) {
    event.preventDefault();
    event.currentTarget.closest('.preview').remove();
  }
}

class Uploader {

  constructor(file, url, previews, template, controller) {
    this.controller = controller;
    this.container = template.content.firstElementChild.cloneNode(true);

    this.container.querySelector('.name').textContent = file.name;
    previews.appendChild(this.container);

    if (this.controller) {
      this.controller.uploadStarted(this);
    }

    this.upload = new DirectUpload(file, url, this);
    this.upload.create((error, blob) => {
      if (error) {
        console.error('Failed to upload file.', file, error);
        this.container.remove();
        if (this.controller) {
          this.controller.uploadFinished(this, false);
        }
      } else {
        // Upload finished.
        this.container.querySelector('input').value = blob.signed_id;
        if (this.controller) {
          this.controller.uploadFinished(this, true);
        }
      }
    });
  }

  // This method is called automatically by DirectUpload (see 3rd param of its constructor).
  directUploadWillStoreFileWithXHR(request) {
    request.upload.addEventListener('progress', event => {
      var progress = Math.round((event.loaded / event.total) * 100);
      var progressBar = this.container.querySelector('.progress-bar');
      progressBar.style.width = `${progress}%`;
      progressBar.innerHTML = `${progress} %`;
    });
  }
}
